import { useMemo } from "react";
import { KPI_CODES } from "../kpiCodes";

export const useGetTotals = (data: any) => {
  const totalImpound: any = useMemo(() => {
    if (data) {
      const value = data.kpiValues.find(
        (item: any) => item.code === KPI_CODES.IMPOUNDS_TOTAL_BALANCE,
      )?.value;

      return value;
    }

    return null;
  }, [data]);

  const closedImpounds: any = useMemo(() => {
    if (data) {
      const value = data.kpiValues.find(
        (item: any) => item.code === KPI_CODES.IMPOUNDS_CLOSED_BALANCE,
      )?.value;

      return value;
    }

    return null;
  }, [data]);

  return { totalImpound, closedImpounds };
};
